import "./src/styles/global.css";
// just theme
require("prismjs/themes/prism-okaidia.css");
// Add line numbering
require("prismjs/plugins/line-numbers/prism-line-numbers.css");
// shell prompts
require("prismjs/plugins/command-line/prism-command-line.css");
